import Home from './views/Home.vue';

export const PrivateRoutes =
[
	{
		path: '/',
		component: Home,
		name: 'index'
	}
]